import { ApiClient } from '@memori-web/shared';
import { env } from '../env.js';
import { getToken } from './session.js';

export const api = new ApiClient({
  baseUrl: env.apiBaseUrl,
  fetch: (input, init) => fetch(input, { ...init, credentials: 'include' }),
  getToken,
});
